import React, { useState, useEffect, useRef } from 'react';
import { useRoutes, useNavigate, useLocation } from 'react-router-dom';
import { routerList } from './router';
import { AliveScope } from 'react-activation';
import { Dialog, Input, Toast } from 'antd-mobile'; 
import './App.css';
import {localSToken} from './utils/storage';
function App() {
  const navigate = useNavigate();
  const Location=useLocation()

  useEffect(() => {  
    const token = localSToken().get();
    if (!token&&Location.pathname=="/album") {
      navigate('/');
    }
  }, [Location]);

  return (
    <div className="App">
      <AliveScope>
        {useRoutes(routerList)}
      </AliveScope>
    </div>
  );
}

export default App;
